<template>
  <div class="app-drawer">
    <div>
      <a href="https://www.prosperafrica.gov" target="_blank">
        <img
          class="app-logo mr-3"
          alt="Prosper Africa logo"
          src="@/assets/img/prosper-africa.svg"
        />
      </a>
    </div>
    <v-list
      nav
    >
      <v-list-item
        to="/"
        exact
        link
      >
        <v-list-item-content>
          <v-list-item-title class="item-title">Prosper Africa Deal Room</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        href="https://www.prosperafrica.gov/services/"
        link
      >
        <v-list-item-content>
          <v-list-item-title class="item-title">Prosper Africa Resource Library</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item to="/sectors/healthcare/investor" exact link>
          <v-list-item-content>
            <v-list-item-title class="item-title">
              Healthcare sector overview
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      <template v-if="isLoggedIn">
        <v-divider class="mb-2"></v-divider>

        <v-list-item to="/edit-profile" exact link>
          <v-list-item-content>
            <v-list-item-title class="item-title">
              <v-icon class="pr-2">mdi-account-circle</v-icon>{{ activeUserInfo.name }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="logout">
          <v-list-item-title class="item-title">Logout</v-list-item-title>
        </v-list-item>
      </template>

    </v-list>
  </div>
</template>

<script>
export default {
  name: 'app-drawer',
  computed: {
    activeUserInfo () {
      return this.$store.getters['user/currentUser']
    },
    isLoggedIn () {
      return this.$store.getters['user/isLoggedIn']
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('user/logout')
        .then(() => {
          this.$router.push('/')
          this.$store.dispatch('deals/list')
        })
        .catch(err => {
          this.$log('err', err)
        })
    }
  }
}
</script>

<style scoped lang="scss">
.app-drawer {
  width: 300px;
}
.app-logo {
  height: 40px;
  padding-left: 20px;
  margin-top: 20px;
}
.item-title {
  text-transform: uppercase;
  font-weight: 500;
  font-size: 14px;
}
</style>
